module.exports = __webpack_public_path__ + "media/images/iconSocialMail__inactive-3c8c9dec4405268f0f30a93525a4181d.png";